<ng-container *nzStringTemplateOutlet="addIcon; let icon">
  <ui-icon [uiType]="icon"></ui-icon>
</ng-container>
